import React, { useEffect } from 'react';

import OnlineOrdersBenefits from 'Comps/ForRestaurants/OnlineOrdersBenefits';
import OnlineOrdersProcess from 'Comps/ForRestaurants/OnlineOrdersProcess';
import PartnerLogos from 'Comps/ForRestaurants/PartnerLogos';
import { createDerivedStateFromErrorLogger } from 'Utils/log';
import CallMeForm from 'Comps/ForRestaurants/CallMeForm';
import { OFFER_TYPES, THEMES } from 'App/config';
import RestaurateurFaq from 'Comps/ForRestaurants/RestaurateurFaq';

const LubJeAddRestaurant = () => {
  useEffect(() => {
    document.querySelector('.until-react-spinner').remove();
  }, []);

  return <>
    <section className="for-restaurants-intro">
      <h1 className="fr-title">Dołącz do LUB*JE</h1>
      <h2 className="fr-subtitle">
        <div>Portal, stworzony przez restauratorów, dla restauratorów i ich zamawiających</div>
      </h2>
      <a href="#fill-form" className="js-scroll-trigger for-restaurants-cta-btn">Zacznij teraz</a>
    </section>
    <section className="for-restaurants-why">
      <h2 className="fr-title">Dlaczego LUB*JE?</h2>
      <OnlineOrdersBenefits type={OFFER_TYPES.LUBJE} />
    </section>
    <section className="cta-try-now" id="fill-form">
      <div className="cta-section__content">
        <h2 className="fr-title">Zacznij już teraz - nie ponosisz żadnego ryzyka!</h2>
        <a href="https://admin.otostolik.pl/signup" target="_blank" rel="noopener noreferrer" className="for-restaurants-cta-btn cta-btn--secondary">Wypełnij formularz zgłoszeniowy</a>
      </div>
    </section>
    <section className="for-restaurants-how">
      <h2 className="fr-title">Jak rozpocząć współpracę?</h2>
      <OnlineOrdersProcess />
      <a href="#fill-form" className="js-scroll-trigger for-restaurants-cta-btn">Rozpocznij współpracę</a>
    </section >
    <CallMeForm
      id="call-me"
      title="Masz pytania i chcesz porozmawiać z żywą osobą?"
      text="Podaj numer telefonu - oddzwonimy w ciągu godziny!"
    />
    <section className="partners">
      <PartnerLogos type="lubje" text="Oni już przyjmują zamówienia z LUB*JE" />
    </section>
    <section className="cta-your-time">
      <div className="cta-section__content">
        <h2 className="fr-title">Teraz Twoja kolej na przyjmowanie zamówień on-line</h2>
        <a href="#fill-form" className="js-scroll-trigger for-restaurants-cta-btn">Wypróbuj teraz</a>
      </div>
    </section>
    <section className="for-restaurants-how text-left pt-2">
      <h4 className="home-title home-title--smaller">Wciąż masz pytania?</h4>
      <RestaurateurFaq theme={THEMES.LUBJE} />
    </section>
    <CallMeForm
      id="call-me"
      title="Czy możemy Ci w czymś jeszcze pomóc?"
      text="Podaj numer telefonu - oddzwonimy w ciągu godziny!"
    />
  </>;
};

LubJeAddRestaurant.getDerivedStateFromError = createDerivedStateFromErrorLogger('LubJeAddRestaurant');

export default LubJeAddRestaurant;
